import React, { useCallback } from "react";
import { Col } from "antd";
import { Form, Select } from "formik-antd";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { TimeSelection, Month, Week, Year } from "./frequencies";

interface FormValues {
  triggerFrequency: string | undefined;
  triggerTime: string;
  triggerInterval: string | undefined;
  triggerNumber: string[] | string;
  triggerMonth: string | undefined;
  workflowId: number | undefined;
}

/**
 * Time component renders form selection input for trigger frequency along with corresponding time selection components.
 * @returns {JSX.Element} The rendered component.
 */
export default function Time() {
  const { values, setFieldValue, setFieldTouched } =
    useFormikContext<FormValues>();

  /**
   * Reset triggerTime, triggerNumber, and triggerMonth when triggerFrequency changes
   */
  const handleFrequencyChange = useCallback(
    (e) => {
      setFieldValue("triggerTime", undefined);
      setFieldValue("triggerNumber", undefined);
      setFieldValue("triggerMonth", undefined);
      setFieldTouched("triggerTime", false);
      setFieldTouched("triggerNumber", false);
      setFieldTouched("triggerMonth", false);
      if (e === "second" && Number(values.triggerInterval) < 10) {
        setFieldValue("triggerInterval", "10");
      }
    },
    [setFieldValue, setFieldTouched, values.triggerInterval],
  );

  const { t } = useTranslation();
  return (
    <>
      <Col span={3}>
        <Form.Item name="triggerFrequency">
          <Select
            name="triggerFrequency"
            size="large"
            onChange={handleFrequencyChange}
          >
            <Select.Option value="second">
              {t("translation:second")}
            </Select.Option>
            <Select.Option value="minute">
              {t("translation:minute")}
            </Select.Option>
            <Select.Option value="hour">{t("translation:hour")}</Select.Option>
            <Select.Option value="day">{t("translation:day")}</Select.Option>
            <Select.Option value="week">{t("translation:week")}</Select.Option>
            <Select.Option value="month">
              {t("translation:month")}
            </Select.Option>
            <Select.Option value="year">{t("translation:year")}</Select.Option>
          </Select>
        </Form.Item>
      </Col>

      {["second", "minute"].includes(values.triggerFrequency) && (
        <Col span={13} />
      )}
      {values.triggerFrequency === "hour" && <TimeSelection format={"mm"} />}
      {values.triggerFrequency === "day" && <TimeSelection />}
      {values.triggerFrequency === "week" && <Week />}
      {values.triggerFrequency === "month" && <Month />}
      {values.triggerFrequency === "year" && <Year />}
      {!values.triggerFrequency && <Col span={13} />}
    </>
  );
}
